import { render, staticRenderFns } from "./EmployeeWorkforceSettings.vue?vue&type=template&id=11ef4f15&scoped=true&"
import script from "./EmployeeWorkforceSettings.vue?vue&type=script&lang=js&"
export * from "./EmployeeWorkforceSettings.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeWorkforceSettings.vue?vue&type=style&index=0&id=11ef4f15&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ef4f15",
  null
  
)

export default component.exports